import API_CONFIG, { getApiUrl } from './config';

const STAFF_TOKEN_KEY = 'staffAuthToken';
const STAFF_ROLE_KEY = 'staffRole';
const STAFF_EMAIL_KEY = 'staffEmail';
const STAFF_RESTAURANT_ID_KEY = 'staffRestaurantId';

class StaffAuthService {
  async login({ email, password, role, restaurantId }) {
    try {
      const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.STAFF_AUTH.LOGIN), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          password,
          role,
          restaurantId
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || 'Unable to sign in');
      }

      const data = responseData.data || responseData;
      this.persistSession(data, { email, role, restaurantId });

      return {
        success: true,
        data
      };
    } catch (error) {
      console.error('Staff login error:', error);
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  }

  persistSession(data, fallbackData) {
    const token = data.authToken || data.token;
    if (token) {
      localStorage.setItem(STAFF_TOKEN_KEY, token);
    }

    localStorage.setItem(STAFF_ROLE_KEY, data.role || fallbackData.role);
    localStorage.setItem(STAFF_EMAIL_KEY, data.email || fallbackData.email);

    const restaurantId = data.restaurantId || fallbackData.restaurantId;
    if (restaurantId) {
      localStorage.setItem(STAFF_RESTAURANT_ID_KEY, restaurantId);
    }
  }

  getAuthToken() {
    return localStorage.getItem(STAFF_TOKEN_KEY);
  }

  getRole() {
    return localStorage.getItem(STAFF_ROLE_KEY);
  }

  isAuthenticated(allowedRoles = []) {
    const token = this.getAuthToken();
    if (!token) {
      return false;
    }

    if (allowedRoles.length === 0) {
      return true;
    }

    return allowedRoles.includes(this.getRole());
  }

  logout() {
    localStorage.removeItem(STAFF_TOKEN_KEY);
    localStorage.removeItem(STAFF_ROLE_KEY);
    localStorage.removeItem(STAFF_EMAIL_KEY);
    localStorage.removeItem(STAFF_RESTAURANT_ID_KEY);
  }
}

const staffAuthService = new StaffAuthService();

export default staffAuthService;
